<div class="display-list-item">
    <app-badge-status
    *ngIf="display.status == 'DISCONTINUED'"
  statusText="{{ displayActions.title ?? '' | translate }}"
  [iconClass]="(displayActions.iconBadgeClass ?? '')"
  [sectionClass]="'w-full flex justify-start'">
</app-badge-status>
  <div class="display-list-item__card flex flex-col lg:flex-row BackgroundWhite">
    <div class="display-list-item__card__info flex flex-col p-6 border-r">
      <div class="display-list-item__card__info__row flex items-center gap-2">
        <p class="display-list-item__card__info__item m-0">
              <ng-container *ngIf="display.displayItems; else showName">
                <span class="display-list-item__value typography-title-m primaryDefault-color px-4">{{ display.displayItems[0]?.colorName ?? '' }}</span><span class="display-list-item__value typography-body-m-light">ID:&nbsp;</span><span class="display-list-item__value typography-body-m-medium">{{ display.name }}</span>
              </ng-container>
              <ng-template #showName>
                <span class="display-list-item__value typography-title-m primaryDefault-color">{{ display.name }}</span>
              </ng-template>
        </p>
        <div class="display-list-item__card__info__item ml-auto">
          <app-badge-status statusText="{{displayActions.badge ?? '' | translate }}" [iconClass]="displayActions.iconBadgeClass ?? ''"></app-badge-status>
        </div>
      </div>
      <div class="px-6 py-4 mb-4 mt-4">
        <app-progress-bar
          [steps]="progressSteps"
          [currentStep]="getCurrentStep(display.status)"
          orientation="horizontal"
          [showDescription]="true">
        </app-progress-bar>
      </div>
      <div class="sale-list-item__divider w-full"></div>
      <div class="grid grid-cols-4 gap-4 py-4">
        <div *ngIf="display.mainMaterialBrand != null" class="flex flex-col items-start">
          <span class="typography-body-m-light">{{'my_displays.marca' | translate}}</span>
          <span class="typography-body-m primaryDefault-color">{{display.mainMaterialBrand}}</span>
        </div>
        <div *ngIf="display.mainMaterialFinish != null" class="flex flex-col items-start">
          <span class="typography-body-m-light">{{'my_displays.finishbutton' | translate}}</span>
          <span class="typography-body-m primaryDefault-color">{{display.mainMaterialFinish}}</span>
        </div>
        <div *ngIf="display.mainMaterialThickness != null" class="flex flex-col items-start">
          <span class="typography-body-m-light">{{'my_displays.grosor' | translate}}</span>
          <span class="typography-body-m primaryDefault-color">{{display.mainMaterialThickness}}</span>
        </div>
        <div *ngIf="display.deliveredDate != null" class="flex flex-col items-start">
          <span class="typography-body-m-light">{{'my_displays.instalacion' | translate}}</span>
          <span class="typography-body-m primaryDefault-color">
            {{ display.instalationDate ?? display.deliveredDate | date : 'dd/MM/yyyy' }}
          </span>
        </div>
      </div>
      <div class="py-4">
        <div *ngIf="display.accountId != null && display.accountName != null && display.accountId != display.fabricatorId" class="flex flex-row items-center">
          <span class="mx-2 yellow-circle"></span>
          <span class="typography-body-m semanticWarning-color">{{'my_displays.related_store' | translate}}</span>
          <span class="px-4 typography-body-m truncate min-w-0" [title]="display.accountName | titlecase">{{display.accountName | titlecase}}</span>
        </div>
      </div>
    </div>
    <div class="display-list-item__card__cta flex flex-col justify-start items-center p-6 gap-6">
      <span class="typography-title-m mt-0 mb-6 text-center">{{ displayActions.title ?? '' | translate }}</span>
      <span class="typography-body-m-light mt-0 mb-6 text-center">{{ displayActions.subtitle ?? '' | translate }}</span>
      <div class="display-list-item__card__cta-buttons flex-flex-col gap-4 w-full">
        <app-button
          *ngIf="displayActions.primaryButton"
          class="w-full mb-6"
          [primary]="true"
          [secondary]="false"
          [size]="'medium'"
          [disabled]="display.status === 'INSTALLED' && !display.deleteRequested"
          (click)="handleClick(displayActions.primaryButton.actionOperation)">
          {{ displayActions.primaryButton.actionMessage ?? '' | translate }}
        </app-button>
        <app-button
          *ngIf="displayActions.secondaryButton" class="w-full"
          [ngClass]="{'py-2': true}"
          [primary]="true"
          [ghost]="true"
          [size]="'medium'"
          [disabled]="display.daysSinceInstalled < 540 && display.status === 'INSTALLED'"
          (click)="handleClick(displayActions.secondaryButton.actionOperation)">
          {{ displayActions.secondaryButton.actionMessage | translate }}
        </app-button>
      </div>
    </div>
  </div>
</div>

<app-confirm-modal
  [isOpen]="isConfirmModalVisible"
  title="{{ modalTitle | translate }}"
  message="{{ modalMessage | translate }}"
  confirmText="{{ 'my_displays.continuar' | translate }}"
  cancelText="{{ 'my_displays.keep' | translate }}"
  [buttonsInRow]="true"
  (onConfirm)="confirmOperation()"
  (onCancel)="isConfirmModalVisible = false"
  (onClose)="isConfirmModalVisible = false"
/>
